export const createSettingsApi = (apiCall: any) => ({
  get: async () => await apiCall("/settings", "GET"),
  save: async (settings: any) => await apiCall("/settings", "POST", settings),
});
